(() => {

  const ROOT_SELECTOR = '.shopify-section--main-product';

  const MOBILE_QUERY = '(max-width: 999px)';



  const WAITLIST_PHRASES = [

    'avisarme cuando esté disponible',

    'avisarme cuando este disponible',

    'unirme a lista de espera',

    'unirme a la lista de espera',

    'notify me when available',

    'notify me when back in stock',

    'join waitlist',

    'join the waitlist'

  ];



  const PERSONALIZATION_PHRASES = [

    'personaliza tu producto',

    'personalización',

    'personalizacion'

  ];



  const REVIEW_PHRASES = ['opiniones', 'reseñas', 'reviews', 'review'];



  function isMobile() {

    return window.matchMedia(MOBILE_QUERY).matches;

  }

  /* Cubitt: "Móvil: cómo se pasan las fotos" en horizontal (clase en .cubitt-pdp-shell): se desliza a los lados y el
     gesto vertical queda para mover la página. */
  function isHorizontalGallery(carousel) {
    return Boolean(carousel.closest('.cubitt-pdp-shell--gallery-horizontal'));
  }



  function normalize(value) {

    return String(value || '')

      .replace(/\s+/g, ' ')

      .trim()

      .toLocaleLowerCase();

  }



  function textFor(element) {

    return normalize(

      `${element?.textContent || ''} ${element?.getAttribute?.('aria-label') || ''}`

    );

  }



  function containsAny(value, phrases) {

    return phrases.some((phrase) => value.includes(phrase));

  }



  /* ---------------------------------------------------------

     REVIEWS

     Keep the existing app block and move the mounted review DOM

     into the redesigned summary. No duplicate widget is created.

     --------------------------------------------------------- */



  function syncReviewSlot(root) {

    const slot = root.querySelector('[data-cubitt-review-slot]');

    if (!slot || slot.querySelector('[data-cubitt-app-block]')) return;



    const blocks = [...root.querySelectorAll('[data-cubitt-app-block]')]

      .filter((block) => !slot.contains(block));



    const reviewBlock = blocks.find((block) => {

      const value = textFor(block);

      return (

        containsAny(value, REVIEW_PHRASES) &&

        !block.closest('.product-info__complementary-products')

      );

    });



    if (reviewBlock) slot.append(reviewBlock);

  }



  /* ---------------------------------------------------------

     PERSONALIZATION CTA

     --------------------------------------------------------- */



  function setPersonalizationLabel(element) {

    const currentText = normalize(element.textContent);

    if (currentText !== 'personaliza tu producto') return;



    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);

    let node;



    while ((node = walker.nextNode())) {

      if (normalize(node.nodeValue) === 'personaliza tu producto') {

        node.nodeValue = 'Personalización';

        return;

      }

    }



    if (!element.children.length) element.textContent = 'Personalización';

  }



  function syncPersonalizationButton(root) {

    const selector = [

      'button',

      'a',

      '[role="button"]',

      '[onclick]',

      '.product-personalizer *'

    ].join(', ');



    const candidates = [...root.querySelectorAll(selector)];



    candidates.forEach((element) => {

      if (element.closest('.product-quick-add')) return;



      const value = textFor(element);

      if (!containsAny(value, PERSONALIZATION_PHRASES)) return;



      /* When Zepto nests the label inside wrappers, style the innermost

         matching clickable node instead of the whole app container. */

      const hasMatchingChild = [...element.children].some((child) =>

        containsAny(textFor(child), PERSONALIZATION_PHRASES)

      );

      if (hasMatchingChild && !element.matches('button, a, [role="button"], [onclick]')) return;



      element.classList.add('cubitt-pdp-personalize-trigger');

      setPersonalizationLabel(element);

    });

  }



  /* ---------------------------------------------------------

     BUY BUTTONS / VARIANT PRICE



     Impact's BuyButtons component replaces the content wrapper of

     custom-button on variant:change. That removes any custom price

     markup. The price map below is server-rendered by Liquid, and we

     restore only the price markup after Impact finishes its native

     availability/label update.

     --------------------------------------------------------- */



  function getMainBuyButtons(root) {

    return root.querySelector('.product-info__buy-buttons buy-buttons');

  }



  function getMainAtc(root) {

    return getMainBuyButtons(root)?.querySelector('button[type="submit"]') || null;

  }



  function getMainProductForm(root) {

    const buyButtons = getMainBuyButtons(root);

    const formId = buyButtons?.getAttribute('form');

    return formId ? document.getElementById(formId) : null;

  }



  function getVariantPriceMap(root) {

    if (root._cubittVariantPriceMap) return root._cubittVariantPriceMap;



    const script = root.querySelector(

      '.product-info__buy-buttons [data-cubitt-variant-prices]'

    );



    if (!script) return {};



    try {

      root._cubittVariantPriceMap = JSON.parse(script.textContent || '{}');

    } catch (error) {

      console.warn('[Cubitt PDP] Unable to parse variant price map.', error);

      root._cubittVariantPriceMap = {};

    }



    return root._cubittVariantPriceMap;

  }



  function getButtonContentElement(button) {

    if (!button) return null;

    return button.getAttribute('is') === 'custom-button'

      ? button.firstElementChild

      : button;

  }



  function createSpan(className, text) {

    const span = document.createElement('span');

    span.className = className;

    span.textContent = text;

    return span;

  }



  function restoreAtcPriceMarkup(root, variant) {

    const mainBuyButtons = getMainBuyButtons(root);

    const formId = mainBuyButtons?.getAttribute('form');

    if (!formId) return;



    const priceMap = getVariantPriceMap(root);

    const priceData = variant ? priceMap[String(variant.id)] : null;



    [...root.querySelectorAll('buy-buttons')]

      .filter((buyButtons) => buyButtons.getAttribute('form') === formId)

      .forEach((buyButtons) => {

        const button = buyButtons.querySelector('button[type="submit"]');

        const content = getButtonContentElement(button);

        if (!button || !content) return;



        const existingLabel = content.querySelector?.('.btn-text-content')?.textContent;

        const nativeLabel = String(existingLabel || content.textContent || '')

          .replace(/\s+/g, ' ')

          .trim();

        if (!nativeLabel) return;



        content.replaceChildren(createSpan('btn-text-content', nativeLabel));



        if (!variant?.available || !priceData?.price) return;



        const separator = createSpan('btn-price-separator', ' | ');

        separator.setAttribute('aria-hidden', 'true');



        const priceContent = document.createElement('span');

        priceContent.className = 'btn-price-content';

        priceContent.append(createSpan('btn-regular-price', priceData.price));



        if (priceData.compare_at_price) {

          const comparePrice = document.createElement('s');

          comparePrice.className = 'btn-compare-price';

          comparePrice.textContent = priceData.compare_at_price;

          priceContent.append(comparePrice);

        }



        content.append(separator, priceContent);

      });

  }



  function variantIsUnavailable(root) {

    const button = getMainAtc(root);

    if (!button) return null;



    const value = textFor(button);

    return (

      button.disabled ||

      button.getAttribute('aria-disabled') === 'true' ||

      value.includes('agotado') ||

      value.includes('sold out') ||

      value.includes('unavailable')

    );

  }



  /* ---------------------------------------------------------

     WAITLIST / BACK IN STOCK

     Keep one real app trigger. Native sold-out ATC stays visible.

     --------------------------------------------------------- */



  function getWaitlistCandidates(root) {

    const candidates = new Set();



    root.querySelectorAll('#BIS_trigger, .BIS_trigger, button, a, [role="button"]')

      .forEach((element) => {

        const value = textFor(element);



        if (

          element.id === 'BIS_trigger' ||

          element.classList?.contains('BIS_trigger') ||

          containsAny(value, WAITLIST_PHRASES)

        ) {

          candidates.add(element);

        }

      });



    document.querySelectorAll('#BIS_trigger, .BIS_trigger')

      .forEach((element) => candidates.add(element));



    return [...candidates];

  }



  function resetWaitlistCandidate(element) {

    element.classList.remove(

      'cubitt-pdp-waitlist-primary',

      'cubitt-pdp-waitlist-duplicate'

    );



    element.parentElement?.classList.remove('cubitt-pdp-waitlist-host');

  }



  function syncWaitlist(root) {

    const unavailable = variantIsUnavailable(root);

    if (unavailable === null) return;



    const candidates = getWaitlistCandidates(root);

    candidates.forEach(resetWaitlistCandidate);



    if (!unavailable) {

      candidates.forEach((element) => {

        element.hidden = true;

      });

      return;

    }



    const insideRoot = candidates.filter((element) => root.contains(element));

    const primary =

      insideRoot.find((element) => textFor(element).includes('avisarme cuando')) ||

      insideRoot.find((element) => element.id === 'BIS_trigger') ||

      insideRoot[0] ||

      candidates[0];



    if (!primary) return;



    candidates.forEach((element) => {

      const isPrimary = element === primary;

      element.hidden = !isPrimary;

      element.classList.toggle('cubitt-pdp-waitlist-duplicate', !isPrimary);

    });



    primary.hidden = false;

    primary.classList.add('cubitt-pdp-waitlist-primary');



    const buyButtonsHost = root.querySelector('.product-info__buy-buttons');

    if (buyButtonsHost && primary.parentElement !== buyButtonsHost) {

      buyButtonsHost.append(primary);

    }



    buyButtonsHost?.classList.add('cubitt-pdp-waitlist-host');

  }



  /* ---------------------------------------------------------

     NATIVE IMPACT GALLERY - MOBILE VERTICAL ADAPTER



     There is only ONE media-carousel. Impact still owns filtering,

     variant featured media, videos/models, zoom and page-dots.

     On mobile we override the instance transition only, so the next

     native slide enters from below without cloning gallery markup.

     --------------------------------------------------------- */



  function galleryItems(carousel) {

    return [...carousel.children]

      .filter((item) => item.classList.contains('product-gallery__media'));

  }



  function visibleGalleryItems(carousel) {

    return galleryItems(carousel).filter((item) => !item.hidden);

  }



  function clearGalleryAnimation(carousel) {

    carousel._cubittAnimations?.forEach((animation) => animation.cancel());

    carousel._cubittAnimations = [];

  }


  function syncMobileGalleryIndicator(carousel, visibleItems = null, selectedItem = null) {
    const gallery = carousel.closest('product-gallery');
    const indicator = gallery?.querySelector('.cubitt-mobile-gallery-indicator');
    if (!indicator) return;

    if (!isMobile()) {
      indicator.hidden = true;
      indicator.replaceChildren();
      return;
    }

    const visible = visibleItems || visibleGalleryItems(carousel);
    if (visible.length <= 1) {
      indicator.hidden = true;
      indicator.replaceChildren();
      return;
    }

    const selected = selectedItem || galleryItems(carousel)[carousel.selectedIndex] || visible[0];
    const activeIndex = Math.max(0, visible.indexOf(selected));

    if (indicator.children.length !== visible.length) {
      const fragment = document.createDocumentFragment();
      visible.forEach(() => {
        const dot = document.createElement('span');
        dot.className = 'cubitt-mobile-gallery-indicator__dot';
        fragment.append(dot);
      });
      indicator.replaceChildren(fragment);
    }

    [...indicator.children].forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });

    indicator.hidden = false;
  }



  function syncMobileGalleryState(carousel) {

    clearGalleryAnimation(carousel);



    const items = galleryItems(carousel);

    items.forEach((item) => {

      item.classList.remove(

        'is-selected',

        'cubitt-mobile-next',

        'cubitt-mobile-previous'

      );

      item.style.removeProperty('visibility');

      item.style.removeProperty('opacity');

      item.style.removeProperty('z-index');

      item.style.removeProperty('transform');

    });



    if (!isMobile()) {

      syncMobileGalleryIndicator(carousel);

      return;

    }



    const visible = visibleGalleryItems(carousel);

    if (!visible.length) return;



    let selected = items[carousel.selectedIndex];

    if (!selected || selected.hidden) {

      selected = visible[0];

      carousel._selectedIndex = items.indexOf(selected);

    }



    const visibleIndex = visible.indexOf(selected);

    const previous = visibleIndex > 0 ? visible[visibleIndex - 1] : null;

    const next = visibleIndex < visible.length - 1 ? visible[visibleIndex + 1] : null;



    selected.classList.add('is-selected');

    previous?.classList.add('cubitt-mobile-previous');

    next?.classList.add('cubitt-mobile-next');

    syncMobileGalleryIndicator(carousel, visible, selected);

  }



  function selectMobileGallery(carousel, index, options = {}) {

    const items = galleryItems(carousel);

    const target = items[index];



    if (!target || target.hidden) {

      const fallback = visibleGalleryItems(carousel)[0];

      if (!fallback) return;

      index = items.indexOf(fallback);

    }



    const indexBeforeChange = carousel.selectedIndex;

    const force = Boolean(options.force);

    const animate = options.animate !== false;



    if (index === indexBeforeChange && !force) {

      syncMobileGalleryState(carousel);

      return;

    }



    const fromSlide = items[indexBeforeChange];

    const toSlide = items[index];

    if (!toSlide) return;



    const visible = visibleGalleryItems(carousel);

    const fromVisibleIndex = visible.indexOf(fromSlide);

    const toVisibleIndex = visible.indexOf(toSlide);

    const direction = options.direction ||

      (toVisibleIndex >= fromVisibleIndex ? 'next' : 'previous');



    carousel._selectedIndex = index;

    carousel._dispatchEvent('carousel:select', index);

    carousel._dispatchEvent('carousel:change', index);



    clearGalleryAnimation(carousel);



    if (!animate || !fromSlide || fromSlide === toSlide) {

      syncMobileGalleryState(carousel);

      carousel._dispatchEvent('carousel:settle', index);

      return;

    }



    const horizontal = isHorizontalGallery(carousel);
    const peekValue = horizontal ? 0 : (parseFloat(
      getComputedStyle(carousel).getPropertyValue('--cubitt-mobile-gallery-peek')
    ) || 44);
    const distance = Math.max(1, (horizontal ? carousel.clientWidth : carousel.clientHeight) - peekValue);
    const axis = horizontal ? 'translateX' : 'translateY';

    const incoming = direction === 'previous' ? -distance : distance;

    const outgoing = direction === 'previous' ? distance : -distance;



    toSlide.style.visibility = 'visible';

    toSlide.style.opacity = '1';

    toSlide.style.zIndex = '4';

    fromSlide.style.visibility = 'visible';

    fromSlide.style.opacity = '1';

    fromSlide.style.zIndex = '3';



    const timing = {

      duration: 330,

      easing: 'cubic-bezier(.22,.8,.24,1)',

      fill: 'both'

    };



    const outgoingAnimation = fromSlide.animate(

      [

        { transform: `${axis}(0)` },

        { transform: `${axis}(${outgoing}px)` }

      ],

      timing

    );



    const incomingAnimation = toSlide.animate(

      [

        { transform: `${axis}(${incoming}px)` },

        { transform: `${axis}(0)` }

      ],

      timing

    );



    carousel._cubittAnimations = [outgoingAnimation, incomingAnimation];



    Promise.allSettled([

      outgoingAnimation.finished,

      incomingAnimation.finished

    ]).then(() => {

      if (carousel.selectedIndex !== index) return;

      syncMobileGalleryState(carousel);

      carousel._dispatchEvent('carousel:settle', index);

    });

  }



  function bindMobileGallerySwipe(carousel, signal) {

    if (carousel.dataset.cubittSwipeBound === 'true') return;

    carousel.dataset.cubittSwipeBound = 'true';



    let startX = 0;

    let startY = 0;

    let pointerId = null;



    carousel.addEventListener('pointerdown', (event) => {

      if (!isMobile() || event.pointerType === 'mouse' || !event.isPrimary) return;

      pointerId = event.pointerId;

      startX = event.clientX;

      startY = event.clientY;

    }, { signal });



    carousel.addEventListener('pointerup', (event) => {

      if (!isMobile() || pointerId !== event.pointerId) return;
      // Cubitt: en horizontal, el dedo lo gestionan los eventos touch de abajo.
      if (isHorizontalGallery(carousel) && event.pointerType === 'touch') {
        pointerId = null;
        return;
      }



      const deltaX = event.clientX - startX;

      const deltaY = event.clientY - startY;

      pointerId = null;



      if (isHorizontalGallery(carousel)) {
        if (Math.abs(deltaX) < 34 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.1) return;
        if (deltaX < 0) {
          carousel.next();
        } else {
          carousel.previous();
        }
        return;
      }

      if (Math.abs(deltaY) < 34 || Math.abs(deltaY) <= Math.abs(deltaX) * 1.1) return;



      if (deltaY < 0) {

        carousel.next();

      } else {

        carousel.previous();

      }

    }, { signal });



    carousel.addEventListener('pointercancel', () => {

      pointerId = null;

    }, { signal });

    /* Cubitt: en iPhone, si el gesto llevaba algo de movimiento vertical, Safari movía la página y cancelaba el gesto
       (pointercancel): costaba pasar las fotos. Se decide la dirección en los primeros píxeles; si es horizontal, la
       página no se mueve y se cambia de foto; si es vertical, la página se desplaza como siempre. */
    let touchX = 0;
    let touchY = 0;
    let touchAxis = null;
    let touchActive = false;

    carousel.addEventListener('touchstart', (event) => {
      touchActive = isMobile() && isHorizontalGallery(carousel) && event.touches.length === 1;
      if (!touchActive) return;
      touchAxis = null;
      touchX = event.touches[0].clientX;
      touchY = event.touches[0].clientY;
    }, { signal, passive: true });

    carousel.addEventListener('touchmove', (event) => {
      if (!touchActive) return;
      if (event.touches.length !== 1) {
        touchActive = false;
        return;
      }
      const deltaX = event.touches[0].clientX - touchX;
      const deltaY = event.touches[0].clientY - touchY;
      if (touchAxis === null && Math.max(Math.abs(deltaX), Math.abs(deltaY)) > 8) {
        touchAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
      }
      if (touchAxis === 'x' && event.cancelable) event.preventDefault();
    }, { signal, passive: false });

    carousel.addEventListener('touchend', (event) => {
      if (!touchActive) return;
      touchActive = false;
      if (touchAxis !== 'x') return;
      const deltaX = event.changedTouches[0].clientX - touchX;
      if (Math.abs(deltaX) < 24) return;
      if (deltaX < 0) {
        carousel.next();
      } else {
        carousel.previous();
      }
    }, { signal });

    carousel.addEventListener('touchcancel', () => {
      touchActive = false;
    }, { signal });

  }



  function patchNativeGallery(root, signal) {

    const carousel = root.querySelector('product-gallery media-carousel');

    if (!carousel || carousel.dataset.cubittVerticalPatched === 'true') return;



    carousel.dataset.cubittVerticalPatched = 'true';

    carousel._cubittNativeSelect = carousel.select.bind(carousel);



    carousel.select = function(index, options = {}) {

      if (!isMobile()) {

        return this._cubittNativeSelect(index, options);

      }



      return selectMobileGallery(this, index, options);

    };



    carousel.addEventListener('carousel:filter', () => {

      requestAnimationFrame(() => {

        if (!root.isConnected) return;



        const selected = galleryItems(carousel)[carousel.selectedIndex];

        if (isMobile() && (!selected || selected.hidden)) {

          const firstVisible = visibleGalleryItems(carousel)[0];

          if (firstVisible) {

            carousel.select(galleryItems(carousel).indexOf(firstVisible), {

              animate: false,

              force: true

            });

            return;

          }

        }



        syncMobileGalleryState(carousel);

      });

    }, { signal });



    bindMobileGallerySwipe(carousel, signal);

    syncMobileGalleryState(carousel);

  }



  function bindResponsiveGallery(root, signal) {

    let frame = 0;



    window.addEventListener('resize', () => {

      if (frame) cancelAnimationFrame(frame);



      frame = requestAnimationFrame(() => {

        frame = 0;

        const carousel = root.querySelector('product-gallery media-carousel');

        if (!carousel?._cubittNativeSelect) return;



        if (isMobile()) {

          syncMobileGalleryState(carousel);

        } else {

          clearGalleryAnimation(carousel);

          galleryItems(carousel).forEach((item) => {

            item.classList.remove(

              'is-selected',

              'cubitt-mobile-next',

              'cubitt-mobile-previous'

            );

            item.style.removeProperty('visibility');

            item.style.removeProperty('opacity');

            item.style.removeProperty('z-index');

            item.style.removeProperty('transform');

          });



          carousel._cubittNativeSelect(carousel.selectedIndex, {

            animate: false,

            force: true

          });

        }

      });

    }, { passive: true, signal });

  }





  /* ---------------------------------------------------------
     PRODUCT INFO SCROLL INDICATOR

     Safari/macOS may hide native scrollbars until the user scrolls.
     Draw a real progress thumb with CSS variables so the affordance
     stays visible whenever the desktop product-info column can scroll.
     --------------------------------------------------------- */

  function syncProductInfoScrollIndicator(root) {
    const productInfo = root.querySelector('safe-sticky.product-info');
    if (!productInfo) return;

    if (isMobile()) {
      productInfo.classList.remove('cubitt-has-scroll-indicator');
      productInfo.style.removeProperty('--cubitt-scroll-thumb-height');
      productInfo.style.removeProperty('--cubitt-scroll-thumb-y');
      return;
    }

    const clientHeight = productInfo.clientHeight;
    const scrollHeight = productInfo.scrollHeight;
    const maxScroll = Math.max(0, scrollHeight - clientHeight);

    if (clientHeight <= 0 || maxScroll <= 2) {
      productInfo.classList.remove('cubitt-has-scroll-indicator');
      productInfo.style.removeProperty('--cubitt-scroll-thumb-height');
      productInfo.style.removeProperty('--cubitt-scroll-thumb-y');
      return;
    }

    /* Cubitt: la pista empezaba arriba del todo de la columna (a la altura del header) y ocupaba toda su altura. Ahora
       empieza donde empieza el texto (padding superior + alineación con la foto) y mide como mucho
       --cubitt-scroll-track-max (CSS, 240px por defecto). */
    const infoStyle = getComputedStyle(productInfo);
    const contentTop = (parseFloat(infoStyle.paddingTop) || 0) + (parseFloat(infoStyle.getPropertyValue('--cubitt-info-align-offset')) || 0);
    const trackMax = parseFloat(infoStyle.getPropertyValue('--cubitt-scroll-track-max')) || 240;
    const trackTop = Math.max(4, Math.min(contentTop, clientHeight - 64));
    const trackHeight = Math.max(40, Math.min(trackMax, clientHeight - trackTop - 8));
    const thumbHeight = Math.max(32, trackHeight * (clientHeight / scrollHeight));
    const travel = Math.max(0, trackHeight - thumbHeight);
    const progress = maxScroll > 0 ? productInfo.scrollTop / maxScroll : 0;
    const thumbY = trackTop + travel * progress;

    productInfo.classList.add('cubitt-has-scroll-indicator');
    productInfo.style.setProperty('--cubitt-scroll-track-y', `${trackTop}px`);
    productInfo.style.setProperty('--cubitt-scroll-track-height', `${trackHeight}px`);
    productInfo.style.setProperty('--cubitt-scroll-thumb-height', `${thumbHeight}px`);
    productInfo.style.setProperty('--cubitt-scroll-thumb-y', `${thumbY}px`);
  }

  /* ---------------------------------------------------------
     ALINEACIÓN CON LA FOTO (escritorio)
     La foto se pinta con object-fit: contain dentro de una caja más alta que ancha, así que su borde superior real
     queda por debajo del de la caja y cambia con el ancho de pantalla. Se mide la foto seleccionada y se baja el
     resumen (--cubitt-info-align-offset) y las miniaturas (--cubitt-thumbs-top) a esa altura.
     --------------------------------------------------------- */
  /* Cubitt: botón de WhatsApp de la app de Guatemala (gty-whatsapp-chat-button): está en un shadow DOM que el CSS de la
     página no alcanza. Mientras se ve la barra fija en móvil sube encima de ella, como el WhatsApp del tema (CSS). */
  function liftChatButtons(lift) {
    document.querySelectorAll('gty-whatsapp-chat-button').forEach((host) => {
      const wrapper = host.shadowRoot?.querySelector('.gty-wacb-wrapper');
      if (!wrapper) return;
      wrapper.style.setProperty('transition', 'translate .2s ease');
      if (lift && window.matchMedia('(max-width: 699px)').matches) wrapper.style.setProperty('translate', '0 -90px');
      else wrapper.style.removeProperty('translate');
    });
  }

  function syncMediaAlignment(root) {
    const productInfo = root.querySelector('safe-sticky.product-info');
    const gallery = root.querySelector('product-gallery, .product-gallery');
    if (!productInfo || !gallery) return;

    const reset = () => {
      productInfo.style.removeProperty('--cubitt-info-align-offset');
      gallery.style.removeProperty('--cubitt-thumbs-top');
    };
    if (isMobile()) { reset(); return; }

    const media = [...gallery.querySelectorAll('.product-gallery__media')].find((item) => !item.hidden && item.getBoundingClientRect().width > 50 && item.getBoundingClientRect().left >= gallery.getBoundingClientRect().left - 2);
    const img = media?.querySelector('img');
    if (!img || !img.naturalWidth || !img.naturalHeight) return;

    /* Cubitt: con la galería fija (position: sticky), a media página la galería está desplazada respecto al texto y la
       diferencia salía como margen (el texto bajaba cientos de px). Se mide en la posición normal: sin sticky durante
       la medida (mismo frame, sin repintado) y se restaura. */
    const pinned = [gallery, productInfo].map((el) => [el, el.style.getPropertyValue('position'), el.style.getPropertyPriority('position')]);
    pinned.forEach(([el]) => el.style.setProperty('position', 'static', 'important'));
    try {
      measureMediaAlignment(img, productInfo, gallery);
    } finally {
      pinned.forEach(([el, value, priority]) => (value ? el.style.setProperty('position', value, priority) : el.style.removeProperty('position')));
    }
  }

  function measureMediaAlignment(img, productInfo, gallery) {
    const rect = img.getBoundingClientRect();
    const cs = getComputedStyle(img);
    const padTop = parseFloat(cs.paddingTop) || 0;
    const contentW = rect.width - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    const contentH = rect.height - padTop - (parseFloat(cs.paddingBottom) || 0);
    if (contentW <= 0 || contentH <= 0) return;
    const renderedH = Math.min(contentH, contentW * (img.naturalHeight / img.naturalWidth));
    const imageTop = rect.top + padTop + (cs.objectFit === 'contain' ? (contentH - renderedH) / 2 : 0);

    const infoRect = productInfo.getBoundingClientRect();
    const contentTop = infoRect.top + (parseFloat(getComputedStyle(productInfo).paddingTop) || 0);
    productInfo.style.setProperty('--cubitt-info-align-offset', `${Math.max(0, Math.round(imageTop - contentTop))}px`);
    gallery.style.setProperty('--cubitt-thumbs-top', `${Math.max(0, Math.round(imageTop - gallery.getBoundingClientRect().top))}px`);
  }

  /* Cubitt: descripción del resumen recortada a N líneas (CSS); aquí solo se decide si hace falta "Leer más" y se abre/cierra. */
  function bindDescriptionToggle(root, signal) {
    const sync = (box) => {
      const prose = box.querySelector('.prose');
      const button = box.querySelector('.product-info__description-toggle');
      if (!prose || !button || box.classList.contains('is-expanded')) return;
      const overflowing = prose.scrollHeight > prose.clientHeight + 2;
      box.classList.toggle('is-overflowing', overflowing);
      button.hidden = !overflowing;
    };
    const boxes = () => root.querySelectorAll('[data-cubitt-description]');
    const observer = new ResizeObserver(() => boxes().forEach(sync));
    boxes().forEach((box) => { sync(box); observer.observe(box); });
    signal.addEventListener('abort', () => observer.disconnect(), { once: true });
    root.addEventListener('click', (event) => {
      const button = event.target.closest?.('.product-info__description-toggle');
      const box = button?.closest('[data-cubitt-description]');
      if (!box) return;
      const expanded = !box.classList.contains('is-expanded');
      box.classList.toggle('is-expanded', expanded);
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.less : button.dataset.more;
      if (!expanded) {
        sync(box);
        if (box.getBoundingClientRect().top < 0) box.scrollIntoView({ block: 'start' });
      }
    }, { signal });
  }

  function bindMediaAlignment(root, signal) {
    let frame = 0;
    const requestSync = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = 0;
        if (root.isConnected) {
          syncMediaAlignment(root);
          root._cubittSyncProductInfoScrollIndicator?.();
        }
      });
    };
    window.addEventListener('resize', requestSync, { passive: true, signal });
    root.addEventListener('carousel:select', requestSync, { signal });
    root.addEventListener('carousel:settle', requestSync, { signal });
    root.querySelectorAll('.product-gallery__media img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', requestSync, { once: true, signal });
    });
    window.addEventListener('load', requestSync, { once: true, signal });
    requestSync();
  }

  function bindProductInfoScrollIndicator(root, signal) {
    const productInfo = root.querySelector('safe-sticky.product-info');
    if (!productInfo) return;

    let frame = 0;
    const requestSync = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = 0;
        if (root.isConnected) syncProductInfoScrollIndicator(root);
      });
    };

    productInfo.addEventListener('scroll', requestSync, { passive: true, signal });
    window.addEventListener('resize', requestSync, { passive: true, signal });

    root._cubittSyncProductInfoScrollIndicator = requestSync;
    requestSync();
  }


  /* ---------------------------------------------------------

     STICKY ADD TO CART



     Reuses the real PDP Add to Cart button instead of creating

     a second product form. Visibility follows the real button:

     if the native CTA is not visible, the compact sticky card is.

     --------------------------------------------------------- */



  function getStickyAtc(root) {

    return root.querySelector('[data-cubitt-sticky-atc]');

  }



  function getStickyVariantImage(variant, fallback) {

    return (

      variant?.featured_media?.preview_image?.src ||

      variant?.featured_image?.src ||

      fallback ||

      ''

    );

  }



  function syncStickyAtc(root, variant) {

    const sticky = getStickyAtc(root);

    const mainAtc = getMainAtc(root);

    if (!sticky || !mainAtc) return;



    const stickyButton = sticky.querySelector('[data-cubitt-sticky-button]');

    const stickyLabel = sticky.querySelector('[data-cubitt-sticky-label]');

    const mainContent = getButtonContentElement(mainAtc);

    const mainLabel = mainContent?.querySelector?.('.btn-text-content')?.textContent ||

      mainContent?.textContent ||

      '';



    if (stickyLabel && mainLabel.trim()) {

      stickyLabel.textContent = mainLabel.replace(/\s+/g, ' ').trim();

    }



    const available = variant ? Boolean(variant.available) : !mainAtc.disabled;

    if (stickyButton) {

      stickyButton.disabled = !available;

      stickyButton.setAttribute('aria-disabled', available ? 'false' : 'true');

      if (stickyLabel?.textContent) {

        stickyButton.setAttribute('aria-label', stickyLabel.textContent.trim());

      }

    }

    sticky.classList.toggle('is-unavailable', !available);



    if (variant) {

      const priceData = getVariantPriceMap(root)[String(variant.id)];

      const priceHost = sticky.querySelector('[data-cubitt-sticky-price]');



      if (priceHost && priceData?.price) {

        priceHost.replaceChildren();



        const regularPrice = document.createElement('span');

        regularPrice.className = 'cubitt-sticky-atc__regular-price';

        regularPrice.textContent = priceData.price;

        priceHost.append(regularPrice);



        if (priceData.compare_at_price) {

          const comparePrice = document.createElement('s');

          comparePrice.className = 'cubitt-sticky-atc__compare-price';

          comparePrice.textContent = priceData.compare_at_price;

          priceHost.append(comparePrice);

        }

      }



      const stickyImage = sticky.querySelector('.cubitt-sticky-atc__image');

      const imageSource = getStickyVariantImage(

        variant,

        sticky.dataset.cubittStickyDefaultImage

      );



      if (stickyImage?.tagName === 'IMG' && imageSource) {

        stickyImage.removeAttribute('srcset');

        stickyImage.removeAttribute('sizes');

        stickyImage.src = imageSource;

      }

    }

  }



  function bindStickyAtc(root, signal) {
    const sticky = getStickyAtc(root);
    const mainAtc = getMainAtc(root);
    const productInfo = root.querySelector('safe-sticky.product-info');
    if (!sticky || !mainAtc || sticky.dataset.cubittBound === 'true') return;

    sticky.dataset.cubittBound = 'true';

    const stickyButton = sticky.querySelector('[data-cubitt-sticky-button]');
    stickyButton?.addEventListener('click', () => {
      const currentMainAtc = getMainAtc(root);
      if (!currentMainAtc || currentMainAtc.disabled) return;
      currentMainAtc.click();
    }, { signal });

    let mainAtcVisible = false;
    let footerVisible = false;
    let mainAtcObserved = false;
    let infoScrollStarted = false;

    /*
     * Sticky reveal gate
     * ------------------
     * Do not reveal the compact ATC after only a tiny amount of scrolling.
     * The client wants the user to get through the short product description
     * first, so the sticky starts helping only once that introductory copy has
     * effectively been passed. This is more stable across products than a
     * fixed 28/48px threshold because descriptions can have different heights.
     */
    const shortDescription = productInfo?.querySelector(
      '.product-info__figma-summary .product-info__description--figma, .product-info__figma-summary .product-info__description'
    );

    const updateVisibility = () => {
      const shouldShow =
        infoScrollStarted &&
        mainAtcObserved &&
        !mainAtcVisible &&
        !footerVisible;

      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      liftChatButtons(shouldShow);
    };

    const syncInfoScrollGate = () => {
      if (!productInfo) {
        infoScrollStarted = true;
        updateVisibility();
        return;
      }

      /* Cubitt: con "galería fija" la columna de información no tiene scroll propio en escritorio (scrollTop siempre 0):
         se usa la misma regla que en móvil, sobre el scroll de la página. */
      const infoHasOwnScroll = productInfo.scrollHeight > productInfo.clientHeight + 2;
      if (isMobile() || !infoHasOwnScroll) {
        const infoRect = productInfo.getBoundingClientRect();
        const infoIsInReadingZone =
          infoRect.top < window.innerHeight * 0.9 &&
          infoRect.bottom > window.innerHeight * 0.12;

        if (!infoIsInReadingZone) {
          updateVisibility();
          return;
        }

        if (shortDescription) {
          const descriptionRect = shortDescription.getBoundingClientRect();
          const headerSafeZone = Math.max(92, window.innerHeight * 0.16);

          /*
           * Reveal only once the bottom of the short description has moved
           * above the upper reading zone. In practice this means the user has
           * scrolled through the description instead of seeing the sticky
           * almost immediately after entering the PDP information.
           */
          if (descriptionRect.bottom <= headerSafeZone) {
            infoScrollStarted = true;
          }
        } else {
          /* Fallback for products without a short description. */
          const fallbackDistance = Math.min(220, window.innerHeight * 0.24);
          if (infoRect.top <= -fallbackDistance) {
            infoScrollStarted = true;
          }
        }
      } else if (shortDescription) {
        const infoRect = productInfo.getBoundingClientRect();
        const descriptionRect = shortDescription.getBoundingClientRect();
        const descriptionBottomInContent =
          descriptionRect.bottom - infoRect.top + productInfo.scrollTop;

        /*
         * Desktop has its own internal product-info scroll. Wait until the
         * description has fully passed the top of that scroll area, with a
         * small extra cushion so the reveal feels intentional rather than
         * immediate.
         */
        const revealAfter = Math.max(0, descriptionBottomInContent + 18);
        if (productInfo.scrollTop >= revealAfter) {
          infoScrollStarted = true;
        }
      } else if (productInfo.scrollTop >= 140) {
        /* Fallback for products without a short description. */
        infoScrollStarted = true;
      }

      updateVisibility();
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === mainAtc) {
          mainAtcObserved = true;
          mainAtcVisible = entry.isIntersecting && entry.intersectionRatio > 0.08;
        } else {
          footerVisible = entry.isIntersecting;
        }
      });

      updateVisibility();
    }, { threshold: [0, 0.08, 0.4, 1] });

    observer.observe(mainAtc);

    const footer = document.querySelector('.footer, footer');
    if (footer) observer.observe(footer);

    /*
     * Cubitt: la puerta solo hace falta hasta que se abre (infoScrollStarted nunca vuelve a false); desde ahí manda el
     * IntersectionObserver. Las lecturas de getBoundingClientRect se agrupan en un frame y los listeners de scroll se
     * quitan al abrirse, en vez de medir en cada evento de scroll durante toda la visita.
     */
    const gateController = new AbortController();
    signal.addEventListener('abort', () => gateController.abort(), { once: true });
    let gateFrame = 0;
    const requestInfoScrollGate = () => {
      if (gateFrame) return;
      gateFrame = requestAnimationFrame(() => {
        gateFrame = 0;
        syncInfoScrollGate();
        if (infoScrollStarted) gateController.abort();
      });
    };
    const gateOptions = { passive: true, signal: gateController.signal };
    productInfo?.addEventListener('scroll', requestInfoScrollGate, gateOptions);
    window.addEventListener('scroll', requestInfoScrollGate, gateOptions);
    window.addEventListener('resize', requestInfoScrollGate, gateOptions);

    signal.addEventListener('abort', () => observer.disconnect(), { once: true });
    root._cubittStickyAtcObserver = observer;

    syncInfoScrollGate();
    syncStickyAtc(root);
  }


  /* ---------------------------------------------------------

     THEME EVENTS

     --------------------------------------------------------- */



  function syncAuxiliaryUi(root) {

    syncReviewSlot(root);

    syncPersonalizationButton(root);

    syncWaitlist(root);

    root._cubittSyncProductInfoScrollIndicator?.();

  }



  function bindThemeEvents(root, signal) {

    const form = getMainProductForm(root);

    if (!form) return;



    form.addEventListener('variant:change', (event) => {

      requestAnimationFrame(() => {

        if (!root.isConnected) return;

        restoreAtcPriceMarkup(root, event.detail?.variant);

        syncStickyAtc(root, event.detail?.variant);

        syncAuxiliaryUi(root);

      });



      setTimeout(() => {

        if (root.isConnected) syncWaitlist(root);

      }, 120);

    }, { signal });

  }



  function initRoot(root) {

    if (root._cubittPdpAbortController) return;



    const controller = new AbortController();

    root._cubittPdpAbortController = controller;



    bindThemeEvents(root, controller.signal);

    bindResponsiveGallery(root, controller.signal);

    bindProductInfoScrollIndicator(root, controller.signal);
    bindMediaAlignment(root, controller.signal);
    bindDescriptionToggle(root, controller.signal);

    bindStickyAtc(root, controller.signal);

    syncAuxiliaryUi(root);



    customElements.whenDefined('media-carousel').then(() => {

      if (root.isConnected) patchNativeGallery(root, controller.signal);

    });



    /* Cubitt: la app de reseñas puede pintar sus estrellas después de los reintentos de abajo (página pesada, red
       lenta) y se quedaban fuera del resumen, bajo los beneficios. Se vigilan solo los bloques de app hasta que el
       resumen tenga sus estrellas (como mucho 20 s). */
    if (root.querySelector('[data-cubitt-review-slot]') && !root.querySelector('[data-cubitt-review-slot] [data-cubitt-app-block]')) {
      const appBlocks = [...root.querySelectorAll('[data-cubitt-app-block]')];
      if (appBlocks.length) {
        const reviewObserver = new MutationObserver(() => {
          syncReviewSlot(root);
          if (root.querySelector('[data-cubitt-review-slot] [data-cubitt-app-block]')) reviewObserver.disconnect();
        });
        appBlocks.forEach((block) => reviewObserver.observe(block, { childList: true, subtree: true, characterData: true }));
        setTimeout(() => reviewObserver.disconnect(), 20000);
        controller.signal.addEventListener('abort', () => reviewObserver.disconnect(), { once: true });
      }
    }

    /* Finite app mount retries. No MutationObserver and no polling. */

    setTimeout(() => {

      if (root.isConnected) syncAuxiliaryUi(root);

    }, 400);



    setTimeout(() => {

      if (root.isConnected) syncAuxiliaryUi(root);

    }, 1200);



    setTimeout(() => {

      if (root.isConnected) syncAuxiliaryUi(root);

    }, 2500);



    setTimeout(() => {

      if (root.isConnected) syncAuxiliaryUi(root);

    }, 5000);

  }



  function init(scope = document) {

    if (scope.matches?.(ROOT_SELECTOR)) initRoot(scope);

    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initRoot);

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', () => init(), { once: true });

  } else {

    init();

  }



  document.addEventListener('shopify:section:load', (event) => {

    init(event.target);

  });



  document.addEventListener('shopify:section:unload', (event) => {

    const root = event.target.matches?.(ROOT_SELECTOR)

      ? event.target

      : event.target.querySelector?.(ROOT_SELECTOR);



    root?._cubittPdpAbortController?.abort();

    if (root) root._cubittPdpAbortController = null;

  });

})();
